var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stat-card',{attrs:{"title":"Net Profit","color":"teal accent-3","amount":_vm.netProfit,"icon":"mdi-chart-line","sub_title":""}}),_c('stat-card',{attrs:{"title":"GST on Net Profit","color":"teal accent-4","amount":_vm.gstOnNetProfit,"icon":"mdi-chart-line","sub_title":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }